import { profileOption, readLinkOption, readWriteLinkOption, writeLinkOption } from '../constants';

function createLinkType(link) {
    if (link.read_tag && link.write_tag) {
        return readWriteLinkOption;
    }
    if (link.read_tag) {
        return readLinkOption;
    }
    if (link.write_tag) {
        return writeLinkOption;
    }
    if (link.patient_table_id) {
        return profileOption;
    }
    return null;
}

function convertQuestionLinkToView(link) {
    return {
        ...link,
        enabled: link.enabled === 1,
        type: createLinkType(link),
        patient_table: link.patient_table_id ? { id: link.patient_table_id } : null,
    };
}

export default convertQuestionLinkToView;
